import { memo } from 'react';
import ExpenseCategoryFilter from 'components/ui/filters/items/ExpenseCategoryFilter';
import ReasonTypeFilter from 'components/ui/filters/items/ReasonTypeFilter';
import DateTypeSelectFilter from 'components/dashboard/items/dateTypeSelectFilter';

const ExpStatFilter = () => {
  return (
    <div className='flex gap-2'>
      <ExpenseCategoryFilter allowClear size='small' query='category_id' />
      <DateTypeSelectFilter size='small' />
      <ReasonTypeFilter allowClear size='small' />
    </div>
  );
};

export default memo(ExpStatFilter);
